(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wi-brand-header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const menu = document.querySelector('.wi-menu');
  if (!menu) return;
  if (!menu.contains(event.target) || event.target.closest('.wi-menu-panel a')) menu.open = false;
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.wi-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});

  } catch(e) { console.error(e); }
})();
})();
